var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 26,
    viewBox: "0 0 18 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.5C5.69837 0.5 3 3.19837 3 6.5V9.80469C1.16274 11.4524 0 13.8375 0 16.5C0 21.471 4.029 25.5 9 25.5C13.971 25.5 18 21.471 18 16.5C18 13.8375 16.8373 11.4524 15 9.80469V6.5C15 3.32431 12.484 0.767328 9.35547 0.572266C9.24237 0.52671 9.1219 0.502219 9 0.5ZM9 2.5C11.2204 2.5 13 4.27963 13 6.5V8.44531C11.7941 7.84535 10.4385 7.5 9 7.5C7.56151 7.5 6.20592 7.84535 5 8.44531V6.5C5 4.27963 6.77962 2.5 9 2.5ZM9 14.5C10.105 14.5 11 15.395 11 16.5C11 17.238 10.595 17.8757 10 18.2227V19.5C10 20.052 9.552 20.5 9 20.5C8.448 20.5 8 20.052 8 19.5V18.2227C7.405 17.8767 7 17.239 7 16.5C7 15.395 7.895 14.5 9 14.5Z",
    fill: "#1D77B7",
    fillOpacity: 0.43
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.bc12c57d94b60ee7ea3e013b3a66193a.svg";
export { ForwardRef as ReactComponent };